




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class TextContent extends Vue {
  @Prop({
    default: ''
  })
  public content!: string;

}
